export default "__VITE_ASSET__C2$9jigu__"